import { render } from "./NoFlightConfirmationBanner.vue?vue&type=template&id=6ef1c8c0"
import script from "./NoFlightConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./NoFlightConfirmationBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__